<template>
  <div
    class="agency-needs-container"
    v-if="isAdmin || profile.status === 'Available'"
  >
    <div class="needs-header">
      <h1 class="needs-title">Agency Needs</h1>
      <v-btn
        v-if="$route.params.id == profile._id"
        color="primary"
        depressed
        rounded
        @click="addNeed"
        class="add-need-btn"
      >
        <v-icon left>mdi-plus</v-icon>
        Add Need
      </v-btn>
    </div>

    <div class="needs-grid">
      <v-card
        v-for="need in needs"
        :key="need._id"
        class="need-card"
        @click="goToDetails(need)"
        hover
      >
        <div class="card-content">
          <div class="need-icon">
            <v-img
              :src="require('@/assets/svg/needs.svg')"
              width="50"
              height="50"
              contain
            />
          </div>

          <div class="need-details">
            <h3 class="need-title">{{ need.title }}</h3>
            <div class="agency-info">
              <!-- <v-btn
                text
                small
                color="primary"
                class="agency-link px-0"
                @click.stop="goToAgencyProfile(need.agency)"
              >
                {{ need.agency_name }}
                <v-icon right small>mdi-open-in-new</v-icon>
              </v-btn> -->
            </div>
            <div class="need-meta">
              <v-chip
                small
                color="purple lighten-5"
                text-color="purple darken-2"
              >
                {{ need.duration }}
              </v-chip>
              <div class="need-actions">
                <v-tooltip bottom v-if="profile._id == need.agency">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      color="primary"
                      @click.stop="onEdit(need)"
                      v-bind="attrs"
                      v-on="on"
                      class="action-btn"
                    >
                      <v-icon size="18">mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit Need</span>
                </v-tooltip>

                <v-tooltip bottom v-if="profile._id == need.agency">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      color="error"
                      @click.stop="onDelete(need)"
                      v-bind="attrs"
                      v-on="on"
                      class="action-btn"
                    >
                      <v-icon size="18">mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Delete Need</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      color="primary"
                      @click.stop="onShare(need)"
                      v-bind="attrs"
                      v-on="on"
                      class="action-btn"
                    >
                      <v-icon size="18">mdi-share-variant</v-icon>
                    </v-btn>
                  </template>
                  <span>Share Need</span>
                </v-tooltip>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card v-if="needs.length == 0 && !loading" class="empty-state">
        <v-card-text class="text-center py-8">
          <v-icon size="64" color="grey lighten-1">mdi-inbox</v-icon>
          <h3 class="mt-4 grey--text text--darken-1">No posted needs</h3>
          <v-btn
            v-if="$route.params.id == profile._id"
            color="primary"
            depressed
            class="mt-4"
            @click="addNeed"
          >
            Create Your First Need
          </v-btn>
        </v-card-text>
      </v-card>
    </div>

    <!-- Dialogs -->
    <agency-create-need
      :dialog="createDialog"
      :onCloseDialog="onCloseCreateDialog"
    />
    <agency-edit-need
      :item="selected"
      :dialog="editDialog"
      :onCloseDialog="onCloseEditDialog"
      v-if="selected && editDialog"
    />
    <confirm-delete-need-dialog
      :deleteDialog="deleteDialog"
      :need="selected"
      :onClose="onCloseConfirmDelete"
      :onDeleted="onDeletedNeed"
    />

    <v-snackbar v-model="snackbar" :timeout="3000" color="success">
      {{ snackMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>

  <div
    v-else-if="profile.status === 'Pending' || profile.status === 'Rejected'"
    class="status-message"
  >
    <v-card class="status-card">
      <v-card-text class="text-center py-8">
        <v-icon size="64" color="warning">mdi-clock</v-icon>
        <h2 class="mt-4">Account Under Review</h2>
        <p class="mt-2 grey--text">
          Please wait for approval/confirmation from Admin
        </p>
        <v-btn color="primary" text class="mt-4" @click="$router.push('/')">
          Back to Home
        </v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import AgencyCreateNeed from "../needs/create/AgencyCreateNeed.vue";
import AgencyEditNeed from "../needs/create/AgencyEditNeed.vue";
import ConfirmDeleteNeedDialog from "../../../components/common/ConfirmDeleteNeedDialog.vue";
export default {
  components: {
    AgencyCreateNeed,
    AgencyEditNeed,
    ConfirmDeleteNeedDialog
  },
  data() {
    return {
      loading: false,
      createDialog: false,
      needs: [],
      selected: null,
      editDialog: false,
      deleteDialog: false,
      snackbar: false,
      snackMessage: null
    };
  },
  computed: {
    ...mapGetters({
      profile: "auth/getProfile"
    }),
    isAdmin() {
      return !this.profile.followers;
    }
  },
  methods: {
    ...mapActions("need", {
      getNeeds: "fetchAgencyNeeds"
    }),
    loadData() {
      this.loading = true;
      this.getNeeds(this.$route.params.id)
        .then(res => {
          this.needs = res;
        })
        .catch(error => {
          console.log(error.response.data.message);
        });
    },
    addNeed() {
      this.createDialog = true;
    },
    onCloseCreateDialog() {
      this.createDialog = false;
      this.loadData();
    },
    goToDetails(item) {
      this.$router.push({
        name: "agency-need-details",
        query: {
          _id: item._id
        }
      });
    },
    onDelete(need) {
      this.selected = need;
      this.deleteDialog = true;
    },
    onDeletedNeed() {
      this.deleteDialog = false;
    },
    onEdit(need) {
      this.selected = need;
      this.editDialog = true;
    },
    onCloseEditDialog() {
      this.editDialog = false;
    },
    onCloseConfirmDelete() {
      this.deleteDialog = false;
    },
    async onShare(need) {
      this.copyToClipboard(
        process.env.VUE_APP_WEB_URL + "/needs/details?_id=" + need._id
      );
      this.snackbar = true;
      this.snackMessage = "Copied the URL";
    },
    copyToClipboard(textToCopy) {
      // navigator clipboard api needs a secure context (https)
      if (navigator.clipboard && window.isSecureContext) {
        // navigator clipboard api method'
        return navigator.clipboard.writeText(textToCopy);
      } else {
        // text area method
        let textArea = document.createElement("textarea");
        textArea.value = textToCopy;
        // make the textarea out of viewport
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        return new Promise((res, rej) => {
          // here the magic happens
          document.execCommand("copy") ? res() : rej();
          textArea.remove();
        });
      }
    },
    goToAgencyProfile(agency) {
      this.$router.push({
        name: "agency-profile-details",
        params: { id: agency }
      });
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>
<style scoped>
.agency-needs-container {
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
}

.needs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
}

.needs-title {
  font-size: 28px;
  font-weight: 600;
  color: #fff;
}

.add-need-btn {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.add-need-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
}

.needs-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 20px;
}

.need-card {
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.need-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.card-content {
  display: flex;
  padding: 20px;
}

.need-icon {
  margin-right: 16px;
  flex-shrink: 0;
}

.need-details {
  flex-grow: 1;
}

.need-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #333;
}

.agency-info {
  margin-bottom: 12px;
}

.agency-link {
  text-transform: none;
  letter-spacing: normal;
  font-weight: 500;
}

.need-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
}

.need-actions {
  display: flex;
  gap: 8px;
}

.action-btn {
  transition: all 0.2s ease;
}

.action-btn:hover {
  transform: scale(1.1);
}

.empty-state {
  grid-column: 1 / -1;
  border: 2px dashed #eee;
  background-color: #fafafa;
}

.status-message {
  /* display: flex; */
  justify-content: center;
  align-items: center;
  /* height: 80vh; */
  margin: 193px;
}

.status-card {
  max-width: 500px;
  border-radius: 16px;
  text-align: center;
}

@media (max-width: 768px) {
  .needs-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .needs-grid {
    grid-template-columns: 1fr;
  }

  .card-content {
    flex-direction: column;
  }

  .need-icon {
    margin-right: 0;
    margin-bottom: 16px;
    align-self: center;
  }

  .need-meta {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .need-actions {
    align-self: flex-end;
  }
}
</style>
